<template>
    <div class="sankey-chart">
        <div id="popup" style="display: none;" v-tippy-html>
            <div v-if="hoveredNode" class="popover-content">
                <h3>{{hoveredNode.data.name}}</h3>
                <div class="amount">{{moneyFormatter(hoveredNode.value)}}</div>
                <div class="percentage">{{numeral(hoveredNode.value / total).format('0.00%')}}</div>
            </div>
        </div>
        <svg :width="width" :height="height" :viewBox="'0 0 '+width+' '+height">
            <g :transform="'translate('+margin.left+','+margin.top+')'">
                <g class="axis">
                    <g ref="xAxis"></g>
                </g>
                <sankey-node :data="computedData" :width="x.bandwidth()" :height="chartHeight" :color="color" :parent-x-axis="x" @detail-hovered="detailHovered" @detail-clicked="detailClicked"></sankey-node>
            </g>
        </svg>
    </div>
</template>
<style lang="scss">
    .sankey-chart{
        svg{
            width: 100%;
            height: auto;
            .axis{
                .domain{
                    display: none;
                }
                .tick{
                    line{
                        display: none;
                    }
                    text{
                        text-transform: uppercase;
                        font-size: 10px;
                        font-weight: 500;
                    }
                }

            }
        }
    }
</style>
<script>
    import SankeyNode from './SankeyNode';
    import * as d3 from 'd3';
    import numeral from 'numeral';
    import moneyFormatter from '../../Methods/MoneyFormatter';

    export default {
        data: function(){
            return {
                hoveredNode: null,
                margin: {
                    top: 30,
                    right: 0,
                    bottom: 0,
                    left: 0
                }
            }
        },
        props: {
            width: {default: 1110},
            height: {default: 848},
            data: {},
            dimensions: {}
        },
        components:{
            SankeyNode
        },
        methods:{
            numeral: numeral,
            moneyFormatter: moneyFormatter,
            detailHovered: function(d){
                this.hoveredNode = d;
            },
            detailClicked: function(d){
                this.$emit('detail-clicked', d);
            }
        },
        computed:{
            chartWidth: function(){
                return this.width - this.margin.left - this.margin.right;
            },
            chartHeight: function(){
                return this.height - this.margin.top - this.margin.bottom;
            },
            x: function(){
                return d3.scaleBand()
                    .paddingInner(0.01)
                    .range([0, this.chartWidth])
                    .domain(['pais','institucion','servicio','area'])
                    .round(true);
            },
            color: function(){
                return d3.scaleOrdinal(['#081D58','#1D91C0','#41B6C4','#F7B538'])
            },
            computedData: function(){
                const root = d3.hierarchy(this.data)
                //.eachBefore(function(d) { d.data.id = (d.parent ? d.parent.data.id + "." : "") + d.data.id; })
                    .sum(function(d){return d.size;})
                    .sort(function(a, b) { return b.height - a.height || b.value - a.value; });

                return root;
            },
            axisTop: function(){
                return d3.axisTop(this.x)
                    .tickPadding(10);
            },
            total: function () {
                return this.computedData.value;
            }
        },
        watch:{
            data: function(){
                d3.select(this.$refs.xAxis).call(this.axisTop);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/Components/Charts/Sankey.vue